<template>
  <div class="base-kinostart">
    <div :class="$mq" class="text" v-html="kinostart"></div>
    <div :class="$mq" class="text2" v-html="kinostart2"></div>
  </div>
</template>

<script>
export default {
  inject: ['kinostart', 'kinostart2'],
}
</script>

<style lang="scss" scoped>
.base-kinostart {
  .text {
    line-height: 1;
    font-family: var(--ff-kinostart);
    color: var(--clr-kinostart);
    font-weight: var(--fw-kinostart);
    text-transform: uppercase;
    font-size: clamp(
      var(--fz-min-kinostart),
      var(--fz-preferred-kinostart),
      var(--fz-max-kinostart)
    );
    &.sm,
    &.md {
      font-size: clamp(1.5rem, 6vw, 4rem);
    }
  }
  .text2 {
    text-transform: uppercase;
    font-size: clamp(0.8rem, 2vw, 3rem);
    &.sm,
    &.md {
      font-size: clamp(1rem, 4vw, 2rem);
    }
  }
}
</style>
